import type { ReactNode } from 'react';

import { WordCloud } from '../../../chrome/chart';
import type { WordCloudTerm } from '../../../chrome/chart/WordCloud';
import type { CommentTermRow } from '../api/schemas';
import { pub } from './messages';

const TONE: Record<CommentTermRow['stance'], WordCloudTerm['tone']> = {
  supportive: 'positive',
  hostile: 'negative',
  neutral: 'neutral',
  off_topic: 'neutral',
};

export function TermsBody(props: { rows: readonly CommentTermRow[] }): ReactNode {
  return (
    <WordCloud
      label={pub('terms.label')}
      terms={props.rows.map((row) => ({
        term: row.term,
        weight: row.count,
        tone: TONE[row.stance],
      }))}
    />
  );
}
